<template>
  <div>
    <Main
      ref="main"
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      @del="del"
    >
      <Header
        slot="header"
        @addGoodsSpec="() => (orderGoodsSpecDialogVisible = true)"
        @batchDel="batchDel"
        :disabled="disabled"
      />
    </Main>
    <choose-order-goods-spec-dialog
      :visible.sync="orderGoodsSpecDialogVisible"
      :title="
        $l('INDEX.dialog_title_choose_order_goods_spec') || '选择订单产品规格'
      "
      :changeOrderCode="changeOrderCode"
      @confirm="orderGoodsSpecConfirm"
      type="checkbox"
      append-to-body
    />
  </div>
</template>
<script>
import Main from './main'
import Header from './header.vue'
import ChooseOrderGoodsSpecDialog from '../../../../choose-components/change-goods-spec/dialog.vue'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: { Main, Header, ChooseOrderGoodsSpecDialog },
  props: {
    orderTechDocCode: { type: String, default: '' },
    changeOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    isExpand: { type: Boolean, default: false }, // 作为标识，判断用户操作是否执行API还是删除缓存中的数据，应为该组件在表格展开插槽中使用也在表格中使用
  },
  data() {
    return {
      loading: false,
      tableData: [],
      orderGoodsSpecDialogVisible: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderTechDocCode) return
      this.loading = true
      this.tableData = []
      this.$api
        .changeOrderTechDocSpecListApi({
          orderTechDocCode: this.orderTechDocCode,
          changeOrderCode: this.changeOrderCode,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
    },
    orderGoodsSpecConfirm(data) {
      if (this.isExpand) {
        this.addDBData(data)
        return
      }
      this.addTableData(data)
    },
    addTableData(data) {
      if (!data || !data.length) return
      const tableData = data
        .map((i) => {
          return {
            identifyGoodsName: i.identifyGoodsName,
            orderGoodsSpecNo: i.orderGoodsSpecNo,
            orderGoodsSpecName: i.orderGoodsSpecName,
            orderGoodsSpecCode: i.orderGoodsSpecCode,
          }
        })
        .filter(
          (i) =>
            this.tableData.findIndex(
              (j) => j.orderGoodsSpecNo === i.orderGoodsSpecNo
            ) < 0
        )
      this.tableData.push(...tableData)
    },
    addDBData(data) {
      const listOrderGoodsSpecCode = data
        .map((i) => i.orderGoodsSpecCode)
        .filter(
          (i) => this.tableData.findIndex((j) => j.orderGoodsSpecCode === i) < 0
        )

      if (listOrderGoodsSpecCode.length !== data.length) {
        this.$message(
          this.$l('inspection_choose_goods_repeat_tips') ||
            '已为您过滤掉重复的产品信息！'
        )
      }

      if (!listOrderGoodsSpecCode || !listOrderGoodsSpecCode.length) return
      const params = {
        orderTechDocCode: this.orderTechDocCode,
        changeOrderCode: this.changeOrderCode,
        listOrderGoodsSpecCode,
      }
      this.loadingOpen()
      this.$api
        .changeOrderTechDocSpecBatchAddApi(params)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          this.getData()
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    batchDel() {
      if (!this.tableData || !this.tableData.length) return
      const delRows = this.$refs.main.getCheckboxRecords()
      if (!delRows) return
      if (this.isExpand) {
        this.delDBData(delRows)
        return
      }
      this.delTableData(delRows)
    },
    delTableData(delRows) {
      const tableData = this.tableData.filter(
        (i) =>
          delRows.findIndex((j) => i.orderGoodsSpecNo == j.orderGoodsSpecNo) < 0
      )
      this.tableData = [...tableData]
    },
    delDBData(delRows) {
      const listSpecCode = delRows.map((i) => i.changeOrderTechDocSpecCode)
      const dataCount = this.tableData.length || 0

      let delTipsText = this.$l('INDEX.tips_delete') || '是否要删除该记录？'
      if (listSpecCode.length >= dataCount)
        delTipsText =
          this.$l('table_del_goods_last_tips') ||
          '执行次操作会导致，该订单验货要求和验货文档也一并删除！是否确认继续删除？'

      this.$confirm(
        delTipsText,
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .changeOrderTechDocSpecBatchDelApi({ listSpecCode })
          .then((res) => {
            this.loadingClose()
            const { status } = res
            if (status !== 200) {
              this.$message.error(
                this.$l('INDEX.tips_delete_no') || '删除失败！'
              )
              return
            }
            this.$message({
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.getData()
            if (listSpecCode.length >= dataCount) this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          })
      })
    },
    del(changeOrderTechDocSpecCode) {
      const delRow = this.tableData.filter(
        (i) => i.changeOrderTechDocSpecCode === changeOrderTechDocSpecCode
      )
      if (this.isExpand) {
        this.delDBData(delRow)
        return
      }
      this.delTableData(delRow)
    },
    getTableData() {
      return this.tableData || []
    },
  },
}
</script>
